import { useLoanRoutes } from "@roc/feature-loans-routes-config";
import { StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import React from "react";
import { useHistory } from "react-router-dom";
import { useServicerLoansStore } from "../../hooks/useServicerLoansStore";
import { ForeclosureLoansForPayoffRequestForm } from "./foreclosureLoansForPayoffRequestForm";

export const ForeclosureLoansForPayoffRequestModal = observer(() => {
  const { push } = useHistory();
  const { payoffNewRequestStore } = useServicerLoansStore();
  const { loanRoutesConfig } = useLoanRoutes();
  return (
    <StandardDialog
      open={payoffNewRequestStore.showForeclosureLoansForPayoffRequestModal}
      title="Payoff Request Form"
      maxWidth="md"
      handleClose={() => payoffNewRequestStore.setShowForeclosureLoansForPayoffRequestModal(false)}
      dialogContent={
        <ForeclosureLoansForPayoffRequestForm
          onSubmit={(loan) => {
            push(loanRoutesConfig.loans(loan).children.payoffRequest.url);
            payoffNewRequestStore.setShowForeclosureLoansForPayoffRequestModal(false);
          }}
          onClose={() => payoffNewRequestStore.setShowForeclosureLoansForPayoffRequestModal(false)}
        />
      }
    />
  );
})